
import React from 'react';
import { Book } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-6 mt-12 border-t border-gray-200 text-center">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-2 mb-2">
          <Book className="h-5 w-5 text-bookRed" />
          <span className="font-serif font-bold text-bookNavy">Does My Book Cover Suck?</span>
        </div>
        <p className="text-sm text-bookGray">
          An honest AI book cover critique tool. For demonstration purposes only.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
